import request from '@/router/axios';
export function getPage(query) {
  return request({
    url: '/mall/grouponinfo/page',
    method: 'get',
    params: query
  });
}
export function addObj(obj) {
  return request({
    url: '/mall/grouponinfo',
    method: 'post',
    data: obj
  });
}
export function getObj(id) {
  return request({
    url: '/mall/grouponinfo/' + id,
    method: 'get'
  });
}
export function delObj(id) {
  return request({
    url: '/mall/grouponinfo/' + id,
    method: 'delete'
  });
}
export function putObj(obj) {
  return request({
    url: '/mall/grouponinfo',
    method: 'put',
    data: obj
  });
}